;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Up_5c7d466ce588db76b3d2ade2572046e5\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M83.812,65.327l-3.016,3.014L50.049,37.592L19.203,68.438l-3.017-3.017l33.863-33.86L83.812,65.327z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Up_5c7d466ce588db76b3d2ade2572046e5");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Up.svg
// module id = 1417
// module chunks = 0